<template>
  <!-- <div v-if="$route.path === '/'" class="text-xs flex items-center justify-center h-8 border-b border-b-gray-200">'문체변경 AI' 오웰만을 이용하고 싶은 고객들을 위한 '오웰 웹 버전'은 2월1일 오픈할 예정입니다. 며칠만 기다려주세요.</div> -->
  <header v-if="$route.meta.isHeaderSticky === false" class="blue-header absolute w-full top-0 bg-white z-[9999] px-0 lg:px-12">
    <div class="header bg-white fixed top-0 w-full z-10 shadow-md lg:relative lg:shadow-none">
      <div class="container mx-auto max-w-full">
        <nav>
          <div class="h-20 flex items-center justify-between">
            <div class="logo">
              <router-link to="/">
                <img src="@/assets/images/logo_bc.png" class="w-[222px] h-auto" />
              </router-link>
            </div>
            <!-- Mobile -->
            <div class="lg:hidden flex items-center">
              <button class="block" @click="drawerOpen"><MenuIcon class="w-9 h-9" /></button>
            </div>

            <TheDrawer @drawer="drawerClose" v-if="isDrawerOpen" :navigation="navigation" />

            <div class="hidden lg:flex text-sm font-bold gap-x-6">
              <div class="flex mr-4">
                <ul class="flex items-center gap-x-6">
                  <li v-for="menu in navigation" v-bind:key="menu">
                    <a class="uppercase" :href="menu.link" v-if="menu.external === true">{{ menu.title }}</a>
                    <router-link v-else-if="menu.type == 'single'" :to="menu.link" class="uppercase">{{ menu.title }}</router-link>
                    <DropdownMenu v-else-if="menu.type == 'nested'" :title="menu.title" :items="menu.submenu" />
                  </li>
                </ul>
              </div>

              <div class="flex items-center">
                <TheSearch />
              </div>

              <div class="flex items-center">
                <router-link to="/signin" class="text-gray-o9">로그인</router-link>
              </div>

              <div class="flex items-center">
                <router-link to="/apply" class="rounded-full border border-bluedot-blue h-[37px] flex items-center justify-center px-7 bg-bluedot-blue text-white transition hover:bg-white hover:text-bluedot-blue">시작하기</router-link>
              </div>
            </div>

          </div>
        </nav>
      </div>
    </div>
  </header>
  <header v-else class="blue-header sticky w-full top-0 bg-white z-[9999] px-0 lg:px-12">
    <div class="header bg-white fixed top-0 w-full z-10 shadow-md lg:relative lg:shadow-none">
      <div v-if="$route.path === '/'" class="lg:hidden text-xs flex items-center justify-center border-b border-b-gray-200 px-5 py-2">'문체변경 AI' 오웰만을 이용하고 싶은 고객들을 위한 '오웰 웹 버전'은 2월1일 오픈할 예정입니다. 며칠만 기다려주세요.</div>
      <div class="container mx-auto max-w-full">
        <nav>
          <div class="h-20 flex items-center justify-between">
            <div class="logo">
              <router-link to="/">
                <img src="@/assets/images/logo_bc.png" class="w-[222px] h-auto" />
              </router-link>
            </div>
            <!-- Mobile -->
            <div class="lg:hidden flex items-center">
              <button class="block" @click="drawerOpen"><MenuIcon class="w-9 h-9" /></button>
            </div>

            <TheDrawer @drawer="drawerClose" v-if="isDrawerOpen" :navigation="navigation" />

            <div class="hidden lg:flex text-sm font-bold gap-x-6">
              <div class="flex mr-4">
                <ul class="flex items-center gap-x-6">
                  <li v-for="menu in navigation" v-bind:key="menu">
                    <a class="uppercase" :href="menu.link" v-if="menu.external === true">{{ menu.title }}</a>
                    <router-link v-else-if="menu.type == 'single'" :to="menu.link" class="uppercase">{{ menu.title }}</router-link>
                    <DropdownMenu v-else-if="menu.type == 'nested'" :title="menu.title" :items="menu.submenu" />
                  </li>
                </ul>
              </div>

              <div class="flex items-center">
                <TheSearch />
              </div>

              <div class="flex items-center">
                <router-link to="/signin" class="text-gray-o9">로그인</router-link>
              </div>

              <div class="flex items-center">
                <router-link to="/apply" class="rounded-full border border-bluedot-blue h-[37px] flex items-center justify-center px-7 bg-bluedot-blue text-white transition hover:bg-white hover:text-bluedot-blue">시작하기</router-link>
              </div>
            </div>

          </div>
        </nav>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref } from 'vue'
import { MenuIcon } from '@heroicons/vue/outline'
import DropdownMenu from '@/components/DropdownMenu.vue'
import TheSearch from './TheSearch.vue'
import TheDrawer from './TheDrawer.vue'
import MainMenu from '@/data/MainMenu'

const isDrawerOpen = ref(false)

function drawerOpen () {
  isDrawerOpen.value = true
  document.body.classList.add('view-mobile-menu')
}

function drawerClose () {
  isDrawerOpen.value = false
  document.body.classList.remove('view-mobile-menu')
}

const navigation = ref(MainMenu)
</script>
